import { render, staticRenderFns } from "./BiosignalsBlocksTable.vue?vue&type=template&id=3e953264&scoped=true"
import script from "./BiosignalsBlocksTable.vue?vue&type=script&lang=js"
export * from "./BiosignalsBlocksTable.vue?vue&type=script&lang=js"
import style0 from "./BiosignalsBlocksTable.vue?vue&type=style&index=0&id=3e953264&prod&lang=css"
import style1 from "./BiosignalsBlocksTable.vue?vue&type=style&index=1&id=3e953264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e953264",
  null
  
)

export default component.exports